import React, { useCallback } from 'react';
import type { CheckboxOption } from '@/components/Filters/CheckboxFilterSidebar';
import { CheckboxFilterSidebar } from '@/components/Filters/CheckboxFilterSidebar';

export type GuestOption = {
    value: string;
    label: string;
};

type Props = {
    options: GuestOption[];
    selected: string[];
    onChangeSelected: (ids: string[]) => void;

    onResetAll?: () => void;
    maxHeight?: number | string;
    showReset?: boolean;
};

export const GuestsFilterSidebar: React.FC<Props> = ({
                                                         options,
                                                         selected,
                                                         onChangeSelected,
                                                         onResetAll,
                                                         maxHeight = '60vh',
                                                         showReset = false,
                                                     }) => {
    const handleReset = useCallback(() => {
        onResetAll?.();
    }, [onResetAll]);

    const checkboxOptions: CheckboxOption[] = options;

    return (
        <CheckboxFilterSidebar
            title="Filter interviews"
            options={checkboxOptions}
            selected={selected}
            onChangeSelected={onChangeSelected}
            maxHeight={maxHeight}
            showReset={showReset}
            onResetAll={handleReset}
            emptyText="No matches"
        />
    );
};
